module.exports = __webpack_public_path__ + "img/variable.7fb61ef3.jpg";